import { getConfig } from '@configs/evnConfig'

export const COPILOT_URL = `${getConfig(process.env.ACKO_ENV)?.copilotUrl}`
